<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.payment}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{labels.paytMode}}</v-subheader>
            <div>{{paytMode}}</div>
          </v-flex>
          <template v-if="commonForm.paytMode === 'CC'">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.paytCCNo}}</v-subheader>
              <div v-if="commonForm.paytCCNo">{{commonForm.paytCCNo}}</div>
              <div v-else> - </div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.paytCCName}}</v-subheader>
              <div v-if="commonForm.paytCCName">{{commonForm.paytCCName}}</div>
              <div v-else> - </div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.paytExpDate}}</v-subheader>
              <div v-if="commonForm.paytCCExpMth">{{paytCCExpMth}}-{{commonForm.paytCCExpYr}}</div>
              <div v-else> - </div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.paytCCCvv}}</v-subheader>
              <div v-if="commonForm.paytCCCvv">{{commonForm.paytCCCvv}}</div>
              <div v-else> - </div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.paytInstalmentPlan}}</v-subheader>
              <div v-if="commonForm.paytInstalmentPlan">{{commonForm.paytInstalmentPlan}}</div>
              <div v-else> - </div>
            </v-flex>
          </template>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { paymentMode } from '@/const/underwriting/motor'

export default {
  data() {
    return {
      labels: {
        payment: 'Payment Information',
        paytMode: 'Payment Mode',
        paytCCNo: 'Credit Card No.',
        paytCCName: 'Name on Card',
        paytExpDate: 'Expiry Date',
        paytCCCvv: 'CCV/CVC',
        paytInstalmentPlan: 'Instalment Plan'
      }
    }
  },
  computed: {
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    query() {
      return this.$store.state.agency.quotation.queryInfo
    },
    paytCCExpMth() {
      if (this.commonForm.paytCCExpMth) {
        if (this.commonForm.paytCCExpMth < 10) {
          return '0' + this.commonForm.paytCCExpMth
        } else {
          return this.commonForm.paytCCExpMth
        }
      } else {
        return ''
      }
    },
    paytMode() {
      if (this.commonForm.paytMode) {
        return paymentMode[this.commonForm.paytMode]
      } else {
        return ' - '
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">

</style>
